import Network from '../../lib/network/network'
import gettEnv from '../../config/gettEnv'

const gatewayUrl = gettEnv.DELIVERY_GATEWAY_HOSTNAME
const baseUrl = `${gatewayUrl}/api/v1/`
const network = new Network(baseUrl)

export const reschedule = (deliveryUuid: string) => {
  return network.post(`public/deliveries/${deliveryUuid}/cancel`)
}
